export const pageview = () => {
  window.fbq("track", "PageView");
};

export const viewContent = (product) => {
  window.fbq("track", "ViewContent", {
    content_ids: [product.id],
    content_name: product.name,
    content_type: "product",
    value: product.sellprice,
    currency: "THB",
  });
};

export const addToCart = (product) => {
  window.fbq("track", "AddToCart", {
    content_ids: [product.id],
    content_name: product.name,
    content_type: "product",
    value: product.sellprice,
    currency: "THB",
  });
};

export const initiateCheckout = (cartTotal) => {
  window.fbq("track", "InitiateCheckout", {
    value: cartTotal,
    currency: "THB",
  });
};

export const purchase = (order) => {
  window.fbq("track", "Purchase", {
    value: order.amount,
    currency: "THB",
    content_id: order.id,
  });
};
